import {
  GET_SUB_CATEGORY_DETAILS_RESPONSE,
  SUB_CATEGORIES_LIST_RESPONSE,
  SUB_CATEGORY_PRODUCTS_LIST_RESPONSE
} from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  subCategoryDetails: {},
  subCategoryProducts: {
    list: [],
    meta: {}
  }
};

const subCategories = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SUB_CATEGORIES_LIST_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta
      };
    case GET_SUB_CATEGORY_DETAILS_RESPONSE:
      return {
        ...state,
        subCategoryDetails: action.payload
      };
    case SUB_CATEGORY_PRODUCTS_LIST_RESPONSE:
      return {
        ...state,
        subCategoryProducts: {
          list: action.payload.list,
          meta: action.payload.meta
        }
      };
    default:
      return state;
  }
};

export default subCategories;
